import { render, staticRenderFns } from "./BiosignsStatsComponent.vue?vue&type=template&id=6d1dfd5a"
import script from "./BiosignsStatsComponent.vue?vue&type=script&lang=js"
export * from "./BiosignsStatsComponent.vue?vue&type=script&lang=js"
import style0 from "./BiosignsStatsComponent.vue?vue&type=style&index=0&id=6d1dfd5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports